import React from "react"
import { useInView } from "react-intersection-observer"
import Lottie from "@shared/uiNew/LazyLottie"
import * as styles from "./MarkedTitle.module.scss"

type Variant = "program" | "topics" | "speakers"

type Props = {
  children: React.ReactNode
  markerAnimationData: unknown
  variant?: Variant
  className?: string
  threshold?: number
  triggerOnce?: boolean
}

const cx = (...classes: Array<string | undefined | false>) => classes.filter(Boolean).join(" ")

export const MarkedTitle: React.FC<Props> = ({ children, markerAnimationData, variant = "program", className, threshold = 0.2, triggerOnce = true }) => {
  const { ref, inView } = useInView({ threshold, triggerOnce })

  return (
    <span ref={ref} className={cx(styles.root, styles[variant], className)}>
      {children}
      {inView && <Lottie className={styles.marker} animationData={markerAnimationData} loop={false} autoplay />}
    </span>
  )
}
